import { useEffect, useState } from 'react'

import cn from 'classnames'

import { FilterTooltipProps } from './filter-tooltip.props'
import styles from './styles.module.scss'
import CrossIcon from './icons/cross.svg'
import { useTranslation } from 'utils/use-translation'

export default function FilterTooltip({ type, content, onClose, imgSrc, isDestroying }: FilterTooltipProps) {
  const { t } = useTranslation()

  const [isVisible, setIsVisible] = useState(true)
  const [screenWidth, setScreenWidth] = useState<number>(0)

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(() => onClose(), 300)
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setScreenWidth(window.innerWidth)
    }
  }, [])

  useEffect(() => {
    if (!isVisible && type !== null && isDestroying) {
      const timer = setTimeout(() => {
        if (onClose) {
          onClose()
        }
      }, 300)

      return () => clearTimeout(timer)
    }
    return undefined
  }, [isVisible, onClose])

  useEffect(() => {
    if (isDestroying) {
      setIsVisible(false)
    }
  }, [isDestroying])

  return (
    <div
      onClick={screenWidth < 765 ? handleClose : null}
      className={`${styles.filter} ${!isVisible ? styles.fadeOut : ''}`}
    >
      {type && <p>{t(type.toLowerCase())}:</p>}
      <span>
        {type?.toLowerCase() === 'health'
          ? content.split(',').map((el, index) => (
              <span
                className={cn(
                  { [styles.green]: el.trim()?.toLowerCase() === 'green' || el.trim() === t('green')},
                  { [styles.orange]: el.trim()?.toLowerCase() === 'orange' || el.trim() === t('orange')},
                  { [styles.red]: el.trim()?.toLowerCase() === 'red' || el.trim() === t('red')},
                )}
                key={index}
              >
                {t(el.toLowerCase())}
                {index !== content.split(',').length - 1 && ','}
              </span>
            ))
          : t(content?.toLowerCase())}{' '}
        {imgSrc && <img className={styles.image} src={imgSrc} alt="arrows image" />}
      </span>
      {onClose !== null && (
        <button>
          <img src={CrossIcon} onClick={handleClose} alt="close filter button" />
        </button>
      )}
    </div>
  )
}
